import React, { useEffect, useState, useContext } from "react";
import SessionContext from "SessionContext";
import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter } from "reactstrap";

function EditCurrent(props) {
  const { itemInfo, onCancel, onUpdate, addSplitCheckbox = false, editingTitle = "", handleChanges } = props;
  const session = useContext(SessionContext);

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [split, setSplit] = useState(false);
  const [showCantDelete, setShowCantDelete] = useState(false);
  const [disableSaveBtn, setDisableSaveBtn] = useState(true);

  useEffect(() => {
    if (!itemInfo) { return; }
    setName(itemInfo.name);
    setDescription(itemInfo.description);
    setSplit(itemInfo.split_by_client || false);
  }, [itemInfo])

  const handleCreate = () => {
    let updated = {...itemInfo, name, description, split_by_client: split};
    onUpdate(updated);
  };

  const handleCancel = () => {
    handleChanges(false);
    onCancel();
  }

  const handleDelete = () => {
    let build_get_query = `admin/get_${editingTitle}`;
    let build_delete_query = `admin/delete_royalty_${editingTitle}`;
    let itemId = itemInfo.id;

    // check if in use
    session.query(build_get_query, { id: itemId })
           .then((response) => {
             if(!response.in_use) {
               deleteItem();
             } else {
               setShowCantDelete(true);
             }
           })
           .catch((error) => {
             console.log(error);
           });

    // only runs if 'in_use' = false
    const deleteItem = () => {
      session.command(build_delete_query, { id: itemId }, {})
             .then(() => {
               handleCancel();
             })
             .catch((error) => {
               console.log(error);
             });
    };
  }

  useEffect(() => {
    let isSplit = (itemInfo && itemInfo.split_by_client) ? itemInfo.split_by_client : false;
    // check for changes
    if( itemInfo && 
      (
        name.trim() === itemInfo.name.trim() &&
        description.trim() === itemInfo.description.trim() &&
        isSplit === split
      )
    ) {
      setDisableSaveBtn(true);
      handleChanges(false);
    } else {
      setDisableSaveBtn(false);
      handleChanges(true);
    }
    // check name has a value
    if(name.trim().length === 0) {
      setDisableSaveBtn(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, description, split, itemInfo])

  return (
    <Form onSubmit={e => e.preventDefault()}>
      <FormGroup row>
        <Label sm={2}>Name:</Label>
        <Col sm={10}>
          <Input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="*Required"
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label sm={2}>Description:</Label>
        <Col sm={10}>
          <Input
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="*Optional"
          />
        </Col>
      </FormGroup>
      {addSplitCheckbox && (
        <Col sm={{size: 10, offset: 2}}>
          <FormGroup check className="split-check">
            <Label check for="split">
              Split Royalty Reporting Out By Client
            </Label>
            <Input
              id="split"
              name="check"
                type="checkbox"
                checked={split}
                onChange={() => setSplit(!split)}
                style={{
                cursor: "pointer",
              }}
            />
          </FormGroup>
        </Col>
      )}

      <FormGroup row className="mt-5">
          <div className="d-grid gap-2 d-md-flex justify-content-md-end">
            <Button onClick={handleDelete}>
              <i className="bi bi-trash3"/>{'  '}
               {editingTitle ? `Delete This ${editingTitle}` : "Delete"}
            </Button>
            {'  '}
            <Button onClick={handleCancel}>Cancel</Button>
            {'  '}
            <Button className="me-md-2 promote" onClick={handleCreate} disabled={disableSaveBtn}>
              Save
            </Button>
          </div>
      </FormGroup>

      {itemInfo &&
        <Modal isOpen={showCantDelete} className="modal-success">
          <ModalBody>
            <h5 className="text-center mb-4 lh-lg">
              <span className="text-capitalize">{editingTitle} </span>
              <span className="font-italic">"{itemInfo.name}" </span> 
              in use by a Royalty Cost and may not be deleted.
            </h5>
          </ModalBody>
          <ModalFooter style={{ justifyContent: "space-around" }}>
            <Button color="secondary" size="md" onClick={() => setShowCantDelete(false)}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      }
    </Form>
  );
}

export default EditCurrent;
